import { css } from 'styled-components';
import { transition } from './animate';
import { fluid } from './fluid';
import brand from '@helpers/brand';
export const headingStyles = css `
  font-weight: 700;
  color: currentColor;
  margin: 0 0 ${fluid(24, 32)};
`;
export const h1 = css `
  ${headingStyles};

  font-size: ${fluid(26, 38)};
  line-height: ${fluid(30, 44)};
`;
export const h2 = css `
  ${headingStyles};

  font-size: ${fluid(22, 34)};
  line-height: ${fluid(26, 38)};
`;
export const h3 = css `
  ${headingStyles};

  font-size: ${fluid(20, 22)};
  line-height: ${fluid(24, 28)};
`;
export const h4 = css `
  ${headingStyles};

  font-size: ${fluid(16, 20)};
  line-height: ${fluid(20, 28)};
`;
export const h5 = css `
  ${headingStyles};

  font-size: ${fluid(16, 18)};
  line-height: ${fluid(24, 27)};
`;
const paragraphStyles = css `
  font-weight: 400;
  color: currentColor;
  margin: 0 0 ${fluid(16, 24)};
`;
export const paragraphLarge = css `
  ${paragraphStyles};

  font-size: ${fluid(18, 20)};
  line-height: ${fluid(27, 30)};
`;
export const paragraph = css `
  ${paragraphStyles};

  font-size: ${fluid(16, 17)};
  line-height: ${fluid(24, 26)};
`;
export const paragraphSmall = css `
  ${paragraphStyles};

  font-size: ${fluid(14, 16)};
  line-height: ${fluid(21, 24)};
`;
export const link = css `
  ${transition('text-decoration-color')};

  display: inline-block;
  color: var(--hyperlink);
  text-decoration: underline;
  text-decoration-color: currentColor;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    text-decoration-color: transparent;
  }
`;
export const subtitle = css `
  ${paragraphStyles};

  font-size: ${fluid(18, 20)};
  line-height: ${fluid(27, 30)};
`;
export const blockquote = css `
  font-weight: 400;
  color: currentColor;
  font-size: ${fluid(18, 21)};
  line-height: ${fluid(27, 31)};
  margin: 0 0 ${fluid(14, 27)};
  padding-left: 28px;
  text-align: left;
  position: relative;

  &::before {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    font-size: 60px;
    line-height: 60px;
  }
`;
export const blockquoteName = css `
  ${paragraphStyles};

  font-size: ${fluid(14, 16)};
  line-height: ${fluid(24, 26)};
  padding-left: 28px;
  text-align: left;

  > strong {
    display: block;
  }
`;
export const table = css `
  background: var(--bgColor);
  border-collapse: collapse;
  color: var(--fgColor);
  margin-bottom: 1em;
  width: 100%;

  thead {
    tr {
      background: #E6E6E6;
      td,
      th {
        font-weight: 700;
        border: 2px solid ${brand.global.black};
        color: var(--fgColor);
        font-size: 18px;
        line-height: 22px;
        padding: 12px 16px;
        text-align: left;
      }
    }
  }

  tbody {
    tr {
      background: ${brand.global.white};

      th {
        font-weight: 700;
        border: 2px solid ${brand.global.black};
        color: var(--bgColor);
        font-size: 18px;
        line-height: 22px;
        padding: 12px 16px;
        text-align: left;
      }

      td {
        font-weight: 400;
        border: 2px solid ${brand.global.black};
        font-size: 16px;
        line-height: 20px;
        padding: 12px 16px;
        text-align: left;
      }
    }
  }
`;
export const contentStyles = css `
  h1,
  .h1-styles {
    ${h1}
  }

  h2,
  .h2-styles {
    ${h2}
  }

  h3,
  .h3-styles {
    ${h3}
  }

  h4,
  .h4-styles {
    ${h4}
  }

  h5,
  .h5-styles {
    ${h5}
  }

  .subtitle {
    ${subtitle}
  }

  p {
    ${paragraph}
  }

  .large {
    ${paragraphLarge}
  }

  .small {
    ${paragraphSmall}
  }

  a {
    ${link};
    font-weight: 700;
  }

  ol,
  ul {
    margin: ${fluid(8, 12)} 0 ${fluid(24, 32)};

    li {
      ${paragraphStyles};
      font-size: ${fluid(16, 17)};
      line-height: ${fluid(24, 27)};
      margin: 0;

      p {
        display: inline;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  ol {
    list-style: decimal;
    padding-left: 1.2em;
  }

  ul {
    list-style: disc;
    padding-left: 1.5em;

    li::before {
      content: '';
      font-weight: bold;
      display: inline-block;
      width: 0.5em;
      margin-left: -0.5em;
      font-size: 230%;
      line-height: 0.5em;
      transform: translate(0%, 25%);
    }
  }

  blockquote {
    ${blockquote};
  }

  .quote-name {
    ${blockquoteName}
  }

  hr {
    display: block;
    background: currentColor;
    border: 0;
    height: 2px;
    margin: ${fluid(32, 48)} 0;
    padding: 0;
    width: 100%;
  }

  table {
    ${table};
  }

  .responsive-table {
    position: relative;
    overflow-x: auto;
  }

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;
